<mat-card>
  <div class="info-row">
    <div class="info-details">
      <span class="title"> {{ TranslationKeys.GeneralVersion | translate }}: </span>
    </div>
    <div class="info-details">
      <span class="details">{{ version }} </span>
    </div>
  </div>
  <div class="info-row">
    <div class="info-details">
      <span class="title"> {{ TranslationKeys.GeneralEnvironment | translate }}: </span>
    </div>
    <div class="info-details">
      <span class="details">{{ environment }} </span>
    </div>
  </div>
  <!-- old MS Teams ACS status row – removed, no longer using CallAgentService
  <div class="info-row" [ngClass]="{ 'not-connected': !(callAgentService.callAgentListening$ | async) }">
    <div class="info-details">
      <span class="title"> MS TEAMS: </span>
    </div>
    <div class="info-details">
      <span class="details"
        >{{
          (callAgentService.callAgentListening$ | async)
            ? (TranslationKeys.GeneralConnected | translate)
            : (TranslationKeys.GeneralNotconnected | translate)
        }}
      </span>
    </div>
  </div>
  -->
  <div class="info-row" [ngClass]="{ 'not-connected': !(assistantHub.isConnected$ | async) }">
    <div class="info-details">
      <span class="title"> signalR: </span>
    </div>
    <div class="info-details">
      <span class="details"
        >{{
          (assistantHub.isConnected$ | async)
            ? (TranslationKeys.GeneralConnected | translate)
            : (TranslationKeys.GeneralNotconnected | translate)
        }}
      </span>
    </div>
  </div>
</mat-card>
